/* Admin: monthly partner targets (blank = auto last month +20%) and the 30 rotating motivational messages. */
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API, getAuthHeader } from "@/App";
import { Button } from "@/components/ui/button";

const api = (m, p, d) => axios({ method: m, url: `${API}${p}`, data: d, headers: getAuthHeader() }).then((r) => r.data);
const err = (e) => toast.error(e?.response?.data?.detail || "Failed");
const inp = "w-28 rounded border px-2 py-1 text-sm";

const Row = ({ r, month }) => {
  const [v, setV] = useState({ parcels: r.parcels || "", amount: r.amount || "" });
  const save = () => api("put", "/portal-admin/targets", { partner_id: r.partner_id, month, ...v }).then(() => toast.success(`${r.name}: target saved`)).catch(err);
  return (
    <tr className="border-t" data-testid={`pt-row-${r.partner_id}`}>
      <td className="px-2 py-1.5"><b>{r.name}</b><div className="font-mono text-[11px] text-slate-400">{r.codes.join(", ")}</div></td>
      <td className="px-2 py-1.5"><input type="number" value={v.parcels} placeholder="auto" onChange={(e) => setV({ ...v, parcels: e.target.value })} className={inp} data-testid={`pt-parcels-${r.partner_id}`} /></td>
      <td className="px-2 py-1.5"><input type="number" value={v.amount} placeholder="auto" onChange={(e) => setV({ ...v, amount: e.target.value })} className={inp} data-testid={`pt-amount-${r.partner_id}`} /></td>
      <td className="px-2 py-1.5 text-xs text-slate-500">{r.partner_parcels || r.partner_amount ? `${r.partner_parcels} parcels · ₹${Number(r.partner_amount).toLocaleString("en-IN")}` : "—"}</td>
      <td className="px-2 py-1.5"><Button size="sm" className="h-7 text-xs" onClick={save} data-testid={`pt-save-${r.partner_id}`}>Save</Button></td>
    </tr>
  );
};

export const TargetsTab = () => {
  const [month, setMonth] = useState(new Date(Date.now() + 19800000).toISOString().slice(0, 7));
  const [d, setD] = useState(null);
  useEffect(() => { setD(null); api("get", `/portal-admin/targets?month=${month}`).then(setD).catch(err); }, [month]);
  return (
    <div className="space-y-2 text-sm" data-testid="pt-targets">
      <div className="flex flex-wrap items-center gap-2"><input type="month" value={month} onChange={(e) => setMonth(e.target.value)} className="rounded border px-2 py-1" data-testid="pt-month" />
        <span className="text-xs text-slate-500">Leave blank for the automatic target: last month's parcels and business + {d?.uplift_pct ?? 20}%. Partners can only raise it.</span></div>
      {!d ? <p className="text-slate-400">Loading…</p> : (
        <div className="max-h-[55vh] overflow-auto rounded border"><table className="w-full"><thead className="bg-slate-50 text-left text-xs text-slate-500"><tr><th className="px-2 py-1.5">Partner</th><th className="px-2 py-1.5">Parcels</th><th className="px-2 py-1.5">Business ₹</th><th className="px-2 py-1.5">Raised by partner</th><th /></tr></thead>
          <tbody>{d.rows.map((r) => <Row key={`${r.partner_id}-${month}`} r={r} month={month} />)}</tbody></table></div>)}
    </div>
  );
};

export const MotivationTab = () => {
  const [text, setText] = useState("");
  useEffect(() => { api("get", "/portal-admin/motivation").then((r) => setText(r.messages.join("\n"))).catch(err); }, []);
  const lines = text.split("\n").filter((l) => l.trim());
  const save = () => api("put", "/portal-admin/motivation", { messages: lines }).then(() => toast.success(`${lines.length} messages saved`)).catch(err);
  return (
    <div className="space-y-2 text-sm" data-testid="pt-motivation">
      <p className="text-xs text-slate-500">One message per line (Hindi or English). Partners see the next one each day; after the last one it starts again from the first.</p>
      <textarea value={text} onChange={(e) => setText(e.target.value)} rows={16} className="w-full rounded border p-2 font-mono text-xs" data-testid="pt-motivation-text" />
      <div className="flex items-center gap-2"><span className="text-xs text-slate-500" data-testid="pt-motivation-count">{lines.length} messages</span><Button size="sm" onClick={save} className="ml-auto" data-testid="pt-motivation-save">Save messages</Button></div>
    </div>
  );
};
